import React from 'react';
import { AtomIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach nuclear energy with confidence starting today'];
export function FinalCta() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-74" data-mp="1jbk7u1shap7l">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-75" data-mp="1ed0ma2hsrffr">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-76" data-mp="1t2ybmlrgqb6j">
          <AtomIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="1o3brdsd7vuo8" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-78" data-mp="22339o5arnx81">
          Created by nuclear energy education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-79" data-mp="n6nvdal2wr2l" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-slate-300/40 bg-blue-950 p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-80" data-mp="n7p77h9x5hld">
          <p data-id="element-81" data-mp="x2h4sl3i44g5">
            <b className="block text-sm uppercase leading-tight text-white" data-id="element-82" data-mp="x64ybk8y4quv">{productShortName}</b>
            <span className="text-sm text-slate-300" data-id="element-83" data-mp="120sfsz5j8kzy">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-84" data-mp="1b28ngz4yq90h">
            <p className="text-sm text-slate-400" data-id="element-85" data-mp="1b173u69vse75">
              <span className="mr-2 line-through" data-id="element-86" data-mp="1fvl0sd46ytdx">{priceBefore}</span>
              <b className="text-base text-white" data-id="element-87" data-mp="1ktwa8mqkr1vm">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-88" data-mp="1psfxcqgwmjpk">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-89" data-mp="1trotu33bwvot">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-90" data-mp="3lwvq7z9zlvnj">
              <CheckIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-91" data-mp="3i4r0y4wvkve" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}